import { defineSlotRecipe } from '@chakra-ui/react';

export const newsletterSlotRecipe = defineSlotRecipe({
    slots: [
        'button',
        'container',
        'formWrapper',
        'headingLg',
        'headingSm',
        'form',
        'formInput',
        'formInputWrapper',
        'formDivider',
        'emailErrorMsg',
        'privacyPolicyTxt',
        'image',
    ],
    base: {
        button: {
            colorPalette: 'secondary',
        },
        container: {
            p: { base: 'gutterWidth', md: 6 },
            mx: { base: '-gutterWidth', md: 0 },
            gap: 4,
            borderRadius: { base: 'none', md: 'xl' },
            position: 'relative',
            justifyContent: 'center',
        },
        formWrapper: {
            display: 'flex',
            flexDirection: 'column',
            minH: '270px',
            alignItems: { base: 'flex-start', md: 'center' },
            textAlign: { base: 'left', md: 'center' },
            width: { base: '100%', md: '75%' },
        },
        headingLg: {
            my: 2,
        },
        headingSm: {
            my: 2,
            '& span': {
                fontSize: 'xl',
            },
        },
        form: {
            background: 'white',
            p: 4,
            borderRadius: 'xl',
            w: 'full',
            mt: { base: 4, md: 6 },
            mb: 2,
        },
        formInputWrapper: {},
        formInput: {
            flex: 1,
            border: 'none',
            focusRing: 'none',
        },
        formDivider: {
            borderColor: 'inherit',
            opacity: 1,
            h: 'auto',
            w: 'auto',
            alignSelf: 'stretch',
            my: 0,
            mx: 0,
        },
        emailErrorMsg: {
            pos: 'absolute',
            left: 3,
            bottom: -4,
            minW: 48,
        },
        privacyPolicyTxt: {
            color: 'gray.500',
            fontSize: 'sm',
            mb: { base: 2, md: 1 },
        },
        image: {
            width: { base: '35%', md: '25%' },
            position: { base: 'absolute', md: 'static' },
            top: -28,
            right: 4,
            zIndex: 0,
        },
    },
});
